import { ReactComponent as Logo } from '../../img/directful-logo.svg'
import styles from './Invoice.module.scss'

const InvoiceHeader = ({ paymentPeriod }) => {
  const shouldDisplayPhysicalCheckInfo = paymentPeriod !== 'Monthly'

  return (
    <div>
      <div className={styles.header}>
        <Logo className={styles.directfulLogo} />
        <div className={styles.swaypayAddress}>
          {shouldDisplayPhysicalCheckInfo && (
            <>
              <p>Make checks payable to:</p>
              <p className={styles.swaypayAddressName}>Directful, Inc</p>
              <p>
                4101 Dublin Blvd
                <br />
                Ste F #3007, Dublin, CA 94568
                <br />
              </p>
              <p>+1 (650) 449-7321</p>
              <p>billing@directful.com</p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default InvoiceHeader
